import { Box, Button, MenuItem, Snackbar, TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Profileheader from './ProfileHeader'
import profileimg from '../../../assets/images/profile/profileimg.jpg';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
  } from "@material-ui/pickers";
import { useDispatch, useSelector } from 'react-redux';
import getBase64 from '../../../core/getBase64';
import { profileSuccess, profileUpdate } from '../../../store/user/actions/profileAction';
import { fnameVali, lnameVali, phVali, ofPhVali, addrVali, countryVali, stdValidator } from '../validation';
import { PROFILE_IMAGE } from '../../../utility/apiConstants';
import { useHistory } from 'react-router';
import profileImg from "../../../assets/images/images/myprofile.png";

const useStyles = makeStyles((theme) => ({
    root: {'& > *': { margin: theme.spacing(1), },},
    input: { display: 'none',}, 
}));

function Editprofile() {
    const classes = useStyles();
    let history = useHistory();
    const dispatch = useDispatch();

    const {userDetails} = useSelector(state => state.user)
    const profileState = useSelector(state => state.profile)



    const [photoError, setPhotoError] = useState({ file:'',  type:'' })
    const [editProfile, setEditProfile] = useState({
        user_id: '',
        title: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        office_phone: '',
        phone: '',
        country_code: '',
        address: '',
        profile_photo: '',
        office_area_code: ''
    });
    const [errorProfile, setErrorProfile] = useState({
        title: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        office_phone: '',
        phone: '',
        country_code: '',
        address: '',
        office_area_code: ''
    });


    const handleChange = (e) => {
        //  //console.loge.target);
        let names = e.target.name;
        let val = e.target.value;
        setEditProfile({ ...editProfile, [names]: val })

    }

    const handlePickNumeric = (e) => {
        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
        if (onlyNums.length < 6) {
         setEditProfile({ ...editProfile, [e.target.name]: onlyNums })
        } 
        else if (onlyNums.length === 10) {
          const number = onlyNums;
          setEditProfile({ ...editProfile, [e.target.name]: number})
        }
        }
    
    const handleSubmit = event => {
        const fnameError = fnameVali(editProfile.first_name)
        const lameError = lnameVali(editProfile.last_name)
        const ofNoError = ofPhVali(editProfile.office_phone)
        const phoneError = phVali(editProfile.phone)
        const countryCodeError = countryVali(editProfile.phone)
        const addressError = addrVali(editProfile.address)
       // const stdError = stdValidator(editProfile.office_area_code)
        if (fnameError || lameError || ofNoError || phoneError || addressError || countryCodeError) {
            setErrorProfile({
                ...errorProfile,
                first_name: fnameError,
                last_name: lameError,
                office_phone: ofNoError,
                phone: phoneError,
                country_code: countryCodeError,
                address: addressError,
               // office_area_code: stdError
            })
            return;
        }
        dispatch(profileUpdate(editProfile, history))
    }
 


    useEffect(() => {
  
        setEditProfile({
            ...editProfile,
                user_id: userDetails?.user_id,
                title: userDetails?.title,
                first_name: userDetails?.first_name,
                last_name: userDetails?.last_name,
                date_of_birth: userDetails?.date_of_birth,
                office_phone: userDetails?.office_phone,
                phone: userDetails?.phone,
                address: userDetails?.address,
                country_code: userDetails?.country_code_value,
                profile_photo: userDetails?.image,
                office_area_code: (userDetails && userDetails.office_area_code) ? userDetails.office_area_code : ""
        })

    }, [userDetails])



    const handleDobDateChange = date => {
      setEditProfile({
          ...editProfile,
          date_of_birth:date
      })
    };
    
    const handleFileRead = async(event)=>{
        const file = event.target.files[0]
        const base64 = await getBase64(file)
        //console.logevent.target.files);
        //console.logbase64);
        if (file.size > 1e6) {
            setPhotoError({
                file: "Please upload a file smaller than 1 MB"
            })
            return false;
        }
        if (file.type != "image/jpeg" && file.type != "image/jpg" && file.type != "image/png" && file.type != "image/svg"){
            setPhotoError({
                type:"Please select a JPG file for upload"
            })
            return false;
        }
        setPhotoError({
            type: ""
        })
        setEditProfile({
            ...editProfile,
            profile_photo:base64
        })
    }

    const handleCancelButton = () =>{
        history.push('/profile')
    }

    const [isOpen, setIsOpen] = useState('');


  
    return (
        <div>
            <Profileheader link="/profile" title="Back"/>
            
            <Container>
                <Row className="itemRow">
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Box className="imguserprofile">
                            <div className="img-ico"><img src={userDetails && userDetails.image ? PROFILE_IMAGE + userDetails?.image : profileImg}></img></div>
                            <div className="choosebtn">
                                <div className={classes.root}>
                                    <input
                                        className={classes.input}
                                        id="contained-button-file"
                                        multiple
                                        type="file"
                                        name="originalFileName"
                                        inputProps={{ accept: 'image/jpg' }}
                                        onChange={handleFileRead}
                                    />
                                    <label htmlFor="contained-button-file">
                                        <Button variant="contained" color="primary" component="span" startIcon={<PhotoCamera />}>                                        Upload
                                        </Button>
                                    </label>
                                </div>
                                <div className="para-txt">Acceptable formats : jpg | jpeg | png | svg only MAX file size is 500 kb and min size 70 kb</div>
                                </div>
                        </Box>
                            {photoError.file && <div className="profilePhotoError"> {photoError.file} </div>}
                            {photoError.type && <div className="profilePhotoError"> {photoError.type} </div>}
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <Box className="editinputfield">
                        <Box className="tlteditname">Title<span>*</span></Box>
                            <Box className="inputBox">
                            <TextField
                                className="titledropdown"
                                id="name-title"
                                select
                                name="title"
                                value={editProfile.title}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                >
                                    <MenuItem value={1}>Mr</MenuItem>
                                    <MenuItem value={2}>Ms</MenuItem>
                                    <MenuItem value={3}>Miss</MenuItem>
                                    <MenuItem value={4}>Master</MenuItem>
                            </TextField>
                            </Box>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <Box className="editinputfield">
                            <Box className="tlteditname">First Name <span>*</span></Box>
                            <Box className="inputBox">
                                <TextField 
                                    className="inputedit" 
                                    variant="outlined" 
                                    size="small" 
                                    inputProps={{ maxLength: 40, }}
                                    placeholder="Krishna" 
                                    value={editProfile.first_name} 
                                    error={!!errorProfile.first_name} 
                                    helperText={errorProfile.first_name}
                                    name='first_name' onChange={handleChange}></TextField>
                            </Box>
                        </Box>
                    </Col>

                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <Box className="editinputfield">
                            <Box className="tlteditname">Last Name <span>*</span></Box>
                            <Box className="inputBox">
                                <TextField 
                                    className="inputedit" 
                                    variant="outlined" 
                                    size="small" 
                                    placeholder="Kumar"
                                    inputProps={{ maxLength: 40, }}
                                    value={editProfile.last_name} 
                                    error={!!errorProfile.last_name}
                                    helperText={errorProfile.last_name}
                                    name='last_name' 
                                    onChange={handleChange}></TextField>
                            </Box>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <Box className="editinputfield">
                            <Box className="tlteditname">Date of Birth <span>*</span></Box>
                            <Box className="inputBox">
                                <MuiPickersUtilsProvider className="Dobselectoredit" spacing={0} utils={DateFnsUtils}>


                                    <KeyboardDatePicker className="editdob"
                                        margin="normal"
                                        variant="inline"
                                        autoOk
                                        inputVariant="outlined"
                                        size="small"
                                        id="date-picker-dialog"
                                        format="dd-MMM-yyyy"
                                        value={editProfile.date_of_birth}
                                        error={!!errorProfile.date_of_birth}
                                        helperText={errorProfile.date_of_birth}
                                        disableFuture
                                        // eslint-disable-next-line react/jsx-no-duplicate-props
                                        maxDate={new Date()}
                                        emptyLabel=""
                                        name='' onChange={handleDobDateChange}
                                        onChange={newDate => {
                                            handleDobDateChange(newDate);
                                            setIsOpen(false);
                                          }}
                                          KeyboardButtonProps={{
                                            onFocus: e => {
                                              setIsOpen(true);
                                            }
                                          }}
                                          PopoverProps={{
                                            disableRestoreFocus: true,
                                            onClose: () => {
                                              setIsOpen(false);
                                            }
                                          }}
                                          InputProps={{
                                            onFocus: () => {
                                              setIsOpen(true);
                                            }
                                          }}
                                          open={isOpen}
                
                                        KeyboardButtonProps={{
                                            "aria-label": "change date"
                                        }}
                                    />
                             </MuiPickersUtilsProvider>
                            </Box>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <Box className="editinputfield">
                            <Box className="tlteditname">Mobile Number <span>*</span></Box>
                            <Box className="inputBox">
                                <Box className="mobiledropdowntxt">
                                    <TextField
                                        className="inputBoxmobile"
                                        variant="outlined"
                                        name="country_code"
                                        value={editProfile.country_code}
                                        error={!!errorProfile.country_code}
                                        helperText={errorProfile.country_code}
                                        onChange={handleChange}
                                        autoComplete="no"
                                    />
                                    <TextField
                                        className="inputedit"
                                        variant="outlined"
                                        size="small"
                                        placeholder="+91 9876543210"
                                        value={editProfile.phone}
                                        error={!!errorProfile.phone}
                                        helperText={errorProfile.phone}
                                        inputProps={{ maxLength: 10 }}
                                        name='phone'
                                        onChange={handleChange}
                                    ></TextField>
                                </Box>
                            
                            </Box>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <Box className="editinputfield">
                            <Box className="tlteditname">Office Number <span>*</span></Box>
                            <Box className="inputBox">
                                <Box className="mobiledropdowntxt">
                                    <TextField
                                            className="inputBoxmobile"
                                            variant="outlined"
                                            name="country_code"
                                            placeholder="Country Code" 
                                            value={editProfile.country_code}
                                            error={!!errorProfile.country_code}
                                            helperText={errorProfile.country_code}
                                            onChange={handleChange}
                                            autoComplete="no"
                                            inputProps={{readOnly: true}}
                                            disabled
                                        />
                                        <TextField
                                            className="inputBoxmobile"
                                            variant="outlined"
                                            name="country_code"
                                            placeholder="STD Code" 
                                            value={editProfile.office_area_code}
                                           // error={!!errorProfile.office_area_code}
                                           // helperText={errorProfile.office_area_code}
                                            onChange={handlePickNumeric}
                                            autoComplete="no"
                                        />
                                    <TextField 
                                        className="inputedit" 
                                        variant="outlined" 
                                        size="small" 
                                        placeholder="080-123456" 
                                        value={editProfile.office_phone}
                                        error={!!errorProfile.office_phone}
                                        helperText={errorProfile.office_phone}
                                        inputProps={{ maxLength: 10 }} 
                                        name='office_phone' 
                                        onChange={handleChange}></TextField>
                                </Box>
                            </Box>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Box className="editinputfield">
                            <Box className="tlteditname">Address <span>*</span></Box>
                            <Box className="inputBox">
                                <TextField 
                                    multiline="true" 
                                    className="inputedit" 
                                    variant="outlined" 
                                    size="small" 
                                    placeholder="Millers Tank Bund Rd, Vasanth Nagar, Bengaluru" 
                                    value={editProfile.address} 
                                    error={!!errorProfile.address} 
                                    helperText={errorProfile.address} 
                                    name='address' 
                                    onChange={handleChange} ></TextField>
                            </Box>
                        </Box>
                    </Col>

                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <Box className="editbtnfield">
                            <Button 
                                className="btnupdate" 
                                variant="contained" 
                                color="primary"
                                onClick={handleSubmit}
                                disabled={profileState.isLoading}
                            >Update</Button>
                            <Button 
                                className="btncancelupdate" 
                                variant="contained" 
                                color="secondary"
                                onClick={handleCancelButton}
                            >Cancel</Button>
                        </Box>
                    </Col>

                </Row>
            </Container>
        </div>
    )
}

export default Editprofile
